import { render, staticRenderFns } from "./DraggableLists.vue?vue&type=template&id=3e631eef&"
import script from "./DraggableLists.vue?vue&type=script&lang=js&"
export * from "./DraggableLists.vue?vue&type=script&lang=js&"
import style0 from "./DraggableLists.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports